module.exports = __webpack_public_path__ + "static/media/payable.f8517a95.svg";